import React, { useEffect, useRef, useState } from 'react';

// eslint-disable-next-line
import { BlurDotBg } from "../jsm/BlurDotBg.module.js";

const BlurGradientWrapper = ({ 
	colors =["#fffce4","#ecd9a7","#c3ea81","#ffeac2"],
  loop = true,
  className = ""
}) => {
  const containerRef = useRef(null);
  const gradientRef = useRef(null);
  const [hasError, setHasError] = useState(false);
  const uniqueId = useRef(`blur-gradient-${Math.random().toString(36).substr(2, 9)}`);

  useEffect(() => {
    // Wait for the DOM to be ready
    if (containerRef.current && !gradientRef.current) {
      try {
        // Set the ID directly on the DOM element
        containerRef.current.id = uniqueId.current;
        
        // Short delay to ensure the DOM is fully ready
        setTimeout(() => {
          try {
            // Initialize with the ID string instead of the DOM element
            // Set noise to 0 to remove the noise effect
            gradientRef.current = new BlurDotBg({
              dom: uniqueId.current, // Use the ID string here, not the DOM element
              colors,
              loop,
              noise: 0.0 // Setting noise to 0 to disable the noise effect
            });
            
            // Alternative approach: update the noise parameter after initialization
            if (gradientRef.current && typeof gradientRef.current.update === 'function') {
              gradientRef.current.update('noise', 0.0);
              console.log("Noise parameter set to 0");
            }
            
            console.log("BlurDotBg initialized successfully without noise");
          } catch (error) {
            console.error("Error initializing BlurDotBg after delay:", error);
            setHasError(true);
          }
        }, 100);
      } catch (error) {
        console.error("Error setting up BlurDotBg:", error);
        setHasError(true);
      }
    }

    // Clean up on unmount
    return () => {
      try {
        if (gradientRef.current && typeof gradientRef.current.destroy === 'function') {
          gradientRef.current.destroy();
          gradientRef.current = null;
        }
      } catch (error) {
        console.error("Error destroying BlurDotBg:", error);
      }
    };
  }, [colors, loop]);

  // If there was an error, use a simple CSS gradient as fallback
  if (hasError) {
    return (
      <div 
        className={`absolute inset-0 ${className}`}
        style={{
          background: `linear-gradient(135deg, ${colors.join(', ')})`,
          zIndex: 0
        }}
      />
    );
  }

  return (
    <div 
      ref={containerRef}
      className={`absolute inset-0 ${className}`}
    />
  );
};

export default BlurGradientWrapper;

			
			